var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgNotification(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.305 16.2233C19.1013 14.75 18.2515 14 18.2515 9.93828C18.2515 6.21875 16.3521 4.89359 14.7888 4.25C14.5811 4.16469 14.3857 3.96875 14.3224 3.75547C14.0482 2.82219 13.2794 2 12.2576 2C11.2357 2 10.4665 2.82266 10.1951 3.75641C10.1318 3.97203 9.9363 4.16469 9.72865 4.25C8.16349 4.89453 6.26599 6.215 6.26599 9.93828C6.26365 14 5.4138 14.75 4.21006 16.2233C3.71131 16.8336 4.14818 17.75 5.02052 17.75H19.4993C20.3669 17.75 20.801 16.8308 20.305 16.2233Z",
    stroke: "#181818",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.2576 17.7492V18.4992C15.2576 19.2949 14.9416 20.0579 14.3789 20.6205C13.8163 21.1831 13.0533 21.4992 12.2576 21.4992C11.462 21.4992 10.6989 21.1831 10.1363 20.6205C9.5737 20.0579 9.25763 19.2949 9.25763 18.4992V17.7492",
    stroke: "#181818",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotification);
export default __webpack_public_path__ + "static/media/notification.60fd4ca4dae263f864eb43a45a491548.svg";
export { ForwardRef as ReactComponent };